import React, { useState, useEffect } from 'react';
import { CalendarRange, LayoutGrid, ClipboardList } from 'lucide-react';
import CalendarBuilder from './content/CalendarBuilder';
import MockupStudio from './content/MockupStudio';
import MonthlyWorkTracker from '../components/MonthlyWorkTracker';

/**
 * ContentPage — hub for the Content feature. Two sub-tabs: Calendars & Mockups.
 * Rendered from both the admin shell (App.js) and the Employee Portal.
 * "Build mockup" on an approved calendar hands the calendar off to the
 * Mockups tab, which seeds a new mockup from it.
 */
export default function ContentPage({ store, persist, showToast, session, openCalendarId, onOpenConsumed }) {
  const [tab, setTab] = useState('calendars');
  const [seed, setSeed] = useState(null);

  const TABS = [
    { id: 'calendars', label: 'Calendars', icon: CalendarRange },
    { id: 'mockups', label: 'Mockups', icon: LayoutGrid },
    { id: 'monthly', label: 'Monthly Work', icon: ClipboardList },
  ];

  // A deep-link into a calendar always lands on the Calendars tab.
  useEffect(() => { if (openCalendarId) setTab('calendars'); }, [openCalendarId]);

  function buildMockup(cal) { setSeed(cal); setTab('mockups'); }

  return (
    <div>
      <div style={{ display: 'inline-flex', gap: 4, padding: 4, background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', marginBottom: 20 }}>
        {TABS.map(({ id, label, icon: Icon }) => (
          <button key={id} onClick={() => setTab(id)} style={{
            display: 'inline-flex', alignItems: 'center', gap: 7, padding: '8px 16px', fontSize: 10.5, fontWeight: 400,
            fontFamily: 'var(--mono)', letterSpacing: '0.1em', textTransform: 'uppercase',
            border: tab === id ? '1px solid var(--border)' : '1px solid transparent', borderRadius: 'var(--radius)', cursor: 'pointer',
            background: tab === id ? 'var(--bg2)' : 'transparent', color: tab === id ? 'var(--text)' : 'var(--text3)',
          }}><Icon size={15} />{label}</button>
        ))}
      </div>

      <div key={tab} className="page-anim">
      {tab === 'calendars' && (
        <CalendarBuilder store={store} persist={persist} showToast={showToast} session={session} onBuildMockup={buildMockup} openCalendarId={openCalendarId} onOpenConsumed={onOpenConsumed} />
      )}
      {tab === 'mockups' && (
        <MockupStudio store={store} persist={persist} showToast={showToast} session={session} seedCalendar={seed} onSeedConsumed={() => setSeed(null)} />
      )}
      {tab === 'monthly' && (
        <MonthlyWorkTracker store={store} persist={persist} session={session} />
      )}
      </div>
    </div>
  );
}
